const degreesPerHalfTurn = 180;
const BaseOfTime = 60;

export const INCHES_PER_FOOT = 12;

export const METRIC = {
  SCALE: {
    milliToBase: 0.001,
    centiToMilli: 10,
    centiToBase: 0.01,
    baseToMilli: 1000,
    kiloToMilli: 1_000_000,
    kiloToBase: 1000,
  },
  LENGTH: {
    metersToIntInches: 39.3701,
  },
  AREA: {
    squareKiloToSquareMeter: 1_000_000,
    squareCentiToSquareMeter: 0.000_1,
    squareMilliToSquareMeter: 1e-6,
  },
};
export const INT_SURVEY = {
  SCALE: {
    inchesToFeet: INCHES_PER_FOOT,
  },
  LENGTH: {
    inchesToMillimeters: 25.4,
    feetToMillimeters: 304.8,
    yardsToMillimeters: 914.4,
    milesToMillimeters: 1_609_344,
  },
  AREA: {
    squareInchesToSquareMeters: 0.00064516,
    squareFeetToSquareMeters: 0.09290304,
    squareYardsToSquareMeters: 0.83612736,
    squareMilesToSquareMeters: 2.59e6,
  },
  VOLUME: {
    cubicInchesToCubicMeters: 0.000016387064,
    cubicFeetToCubicMeters: 0.028316846592,
    cubicYardsToCubicMeters: 0.764554857984,
    cubicMilesToCubicMeters: 4.1682e9,
  },
};
// https://www.nist.gov/pml/us-surveyfoot/revised-unit-conversion-factors
export const US_SURVEY = {
  LENGTH: {
    inchesToMillimeters: 25.4000508, // 0.0254000508 m
    feetToMillimeters: 304.8006096, // 0.304800609601 m
    yardsToMillimeters: 914.4018288, // 0.914401828804 m
    milesToMillimeters: 1609347.219, // 1609.347218694437 m
  },
  AREA: {
    // set to match INT_SURVEY for simplicity, differences are negligible at this scale
    squareInchesToSquareMeters: 0.00064516,
    squareFeetToSquareMeters: 0.09290304,
    squareYardsToSquareMeters: 0.83612736,
    squareMilesToSquareMeters: 2.59e6,
  },
  VOLUME: {
    // set to match INT_SURVEY for simplicity, differences are negligible at this scale
    cubicInchesToCubicMeters: 0.000016387064,
    cubicFeetToCubicMeters: 0.028316846592,
    cubicYardsToCubicMeters: 0.764554857984,
    cubicMilesToCubicMeters: 4.1682e9,
  },
};
export const SHARED = {
  ANGLE: {
    degreesToRadians: Math.PI / degreesPerHalfTurn,
    radiansToDegrees: degreesPerHalfTurn / Math.PI,
    minutesToDegrees: 1 / BaseOfTime,
    secondsToDegrees: 1 / (BaseOfTime * BaseOfTime),
  },
  SLOPE: {
    ratioToDegrees: (value: number): number =>
      Math.atan(value) * (degreesPerHalfTurn / Math.PI),
    ratioToPercent: 100,
    percentToRatio: 0.01,
    degreesToRatio: (value: number): number =>
      Math.tan(value * (Math.PI / degreesPerHalfTurn)),
  },
};
